import Aos from "aos";
import React, { useEffect } from "react";
import boy from "../../assets/Little-boy.png";
import artist from "../../assets/NFT-artist.png";

function Team(props) {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  });
  return (
    <a href id="campaign">
      <div className="flex w-full flex-col md:flex-row justify-center p-10 md:py-10  md:px-40">
        <div className="lg:w-5/12 w-full xl:pr-20 2xl:pr-24 2xl:pl-24">
          <h1
            data-aos="zoom-in"
            className="text-transparent tracking-tight letter-spacing:-0.05em text-2xl md:text-3xl lg:text-5xl 2xl:text-[56px] pb-3 bg-clip-text bg-gradient-to-r from-[#8926B6] to-[#EABCFF] leading-10 mb-8 font-bold "
          >
            The Give a Hand Campaign
          </h1>
          <p
            data-aos="zoom-out"
            className="md:text-xl tracking-tight letter-spacing:-0.05em text-[#747397] lg:text-[18px]"
          >
            20% of each mint will go to fund prosthetic arms for amputees from
            all over the world.
          </p>
          <p
            data-aos="zoom-out"
            className="md:text-xl mt-5 tracking-tight letter-spacing:-0.05em text-[#747397] lg:text-[18px]"
          >
            We will partner with{" "}
            <span className="font-bold tracking-tight letter-spacing:-0.05em text-[#A855CD]">
              Victoria Hands Project
            </span>
            , a non-profit organization that produces 3D printed upper limb
            prostheses that are deployed in countries across the world where
            access to prosthetic care is difficult and costly.
          </p>
        </div>
        <div className="lg:w-5/12 w-full md:pl-[50px] mt-10 mb-10 md:mt-0 lg:pl-[100px]">
          <img src={boy} alt="" className="mb-1 w-full " />
          <div className="mt-10 transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-110 lg:w-3/4 duration-300">
            <a
              href="https://www.victoriahandproject.com/"
              className=" bg-[#646AFB] tracking-tight letter-spacing:-0.05em  text-white text-[16px] lg:text-[22px] rounded-md  py-3 px-10 "
            >
              VHP website link
            </a>
          </div>
        </div>
      </div>
    </a>
  );
}

export default Team;
